import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import NumericKeyPad from '../../components/numeric_keypad/NumericKeyPad'
import Swal from "sweetalert2";
import { Modal } from 'react-bootstrap';
import { AuthFetchAPI } from '../../api/Auth';
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import LoadingAlert from '../../components/Alerts/LoadingAlert';
import QRCode from "react-qr-code";
import logo from '../../components/img/logos/logo.png'
import Socket from '../../utils/Socket.config';
import { Button } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import codepin from './img/icons/codigo-pin.png'



function ApplyCuponRemote() {
    const [displayNumber, setDisplayNumber] = useState("");
    const [numberBaseInput, setNumberBaseInput] = useState("")
    const { business_code, branchoffice_code, machine_code, validcode, token } = useParams();
    const [statusCupon, setstatusCupon] = useState(false);
    const [statusComunicationVending, setStatusComunicationVending] = useState(false);

    const handleNumberClick = (number) => {
        if (displayNumber.length < 10) {
            setNumberBaseInput((prevNumberBaseInput) => prevNumberBaseInput + number);
            if (displayNumber == "") {
                setDisplayNumber("0.0" + number)
            } else {
                if (numberBaseInput.length < 2) {
                    setDisplayNumber("0." + numberBaseInput + number)
                } else {
                    let arrayString = Array.from(numberBaseInput)
                    console.log(arrayString)
                    let numberPart1 = ""
                    let numberPart2 = ""
                    arrayString.forEach((numberNow, index) => {
                        console.log(index)
                        if ((arrayString.length - 1) == index) {
                            numberPart2 = "." + numberNow + number
                        } else {
                            numberPart1 = numberPart1 + numberNow
                        }

                    });
                    setDisplayNumber(numberPart1 + numberPart2)
                }
            }
        }
    };

    const handleNumberClickDelete = () => {
        if (numberBaseInput != "") {
            let arrayString = Array.from(numberBaseInput)
            arrayString.pop()
            let numberPart1 = ""
            let numberPart2 = ""
            let newNumberBaseInput = ""

            arrayString.forEach((numberNow, index) => {
                newNumberBaseInput = newNumberBaseInput + numberNow
                if ((arrayString.length - 1) == index || (arrayString.length - 2) == index) {
                    numberPart2 = numberPart2 + numberNow
                } else {
                    numberPart1 = numberPart1 + numberNow
                }

            });

            if (numberPart1 == "") { numberPart1 = "0" }
            if (numberPart2.length < 2) { numberPart2 = "0" + numberPart2 }


            if (numberPart2 == "00") {
                setNumberBaseInput("")
                setDisplayNumber("")
            } else {
                setNumberBaseInput(newNumberBaseInput)
                setDisplayNumber(numberPart1 + "." + numberPart2)
            }
        }
    };

    const reloadPage = () => {
        window.location.reload();}

    const sendCodeCupon = () => {
        LoadingAlert("Validando cupón, espere un momento por favor");
        setstatusCupon(true);

        // Connection with the sockets server
        const socket = Socket({ "business_code": business_code, "branchoffice_code": branchoffice_code, "machine_code": machine_code });
        // we upate the data when the server send the signal of a new order 


        //let cuponCode = "0000"
        //console.log(displayNumber.length + " : " + displayNumber);
        //if (displayNumber === "" || displayNumber.length < 3) { cuponCode = "0000" } else { cuponCode = displayNumber }
        //1761
        socket.emit('cuponInserted', {
            cuponCode: displayNumber,
            token,
            validCode: validcode,
            machine_code,
            business_code,
            branchoffice_code,
        });

        // Escuchar la validación del cupón
        socket.on('cuponValidated', (response) => {
            console.log('Respuesta de cupón:', response);
            setStatusComunicationVending(true);


            if (response.success) {
                // Mostrar cupón válido
                setstatusCupon(true);
                ErrorAlert("Cupon validado", response.message, "success");
            } else {
                setstatusCupon(false);
                // Mostrar error
                ErrorAlert("Cupón inválido", response.message, "error");
            }


        });

        return () => {
            socket.disconnect();
        }
    }

    return (
        <>


            <main className='keyboard-main-pin  d-flex align-items-center '>

                {statusComunicationVending == false ? <><div className=' d-flex flex-column bd-highlight container'>
                    <div className='d-flex justify-content-center'>
                        <img className='login-kiosk-img-modal border-pin' src={codepin} alt="Logo Smart Pay" />
                    </div>
                    <section className='bd-highlight my-lg-5 my-1 text-center mb-3'>
                        <h2 className="keyboard-title-modal">Ingrese el código del
                            <span className='keyboard-title-modal-brand'> Cupon</span>
                        </h2>
                    </section>

                    <section className='bd-highlight my-lg-5 my-1 text-center mb-3'>
                        <h2 className="keyboard-title-modal">Sesion:
                            <span className='keyboard-title-modal-brand'> {validcode}</span>
                        </h2>
                    </section>
                    <section className='bd-highlight w-100'>
                        <NumericKeyPad displayNumber={displayNumber} setDisplayNumber={setDisplayNumber} placeHolderInput={"0000"} />
                    </section>
                    <section className='bd-highlight row'>
                        {/* <div className='col-md-6'>
                           <button type="button" className=" btn btn-lg btn-vending-secondary btn-vending w-100 text-dark" onClick={() => (handleClearAllData())}>
                           <i className="uil uil-arrow-right"></i> Limpiar 
                           </button>
                        </div> */}
                        <div className='col-12'>
                            <button type="button" className="btn-vending-success w-100 rounded-4 py-lg-3 py-2 pulse fw-bold" onClick={() => (sendCodeCupon())}>
                                Enviar cupon
                            </button></div>
                    </section>
                </div></> : <>
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                            minHeight: '100vh', // Cambia de 60vh a 100vh para centrar verticalmente en toda la pantalla
                            width: '100vw',     // Asegura que ocupe todo el ancho
                            position: 'fixed',  // Fija el contenedor en la pantalla
                            top: 0,
                            left: 0,
                            background: 'rgba(255,255,255,0.95)', // Opcional: fondo semitransparente para resaltar el cartel
                            zIndex: 9999
                        }}
                    >



                        {statusCupon == true ? <><Card className="shadow-lg p-4 border-0" style={{ maxWidth: 400, background: 'linear-gradient(135deg, #e0ffe7 0%, #b2f0e6 100%)' }}>
                            <Card.Body className="text-center">
                                <div style={{ fontSize: 60, color: '#28a745' }}>
                                    <i className="uil uil-smile-beam"></i>
                                </div>
                                <Card.Title className="mb-3 fw-bold" style={{ fontSize: 28, color: '#28a745' }}>
                                    ¡Cupón aplicado!
                                </Card.Title>
                                <Card.Text className="mb-4" style={{ fontSize: 18 }}>
                                    Tu cupón ha sido validado exitosamente.<br />
                                    <span className="fw-bold">¡Gracias por tu compra!</span>
                                </Card.Text>
                                <div>
                                    <img src={logo} alt="Logo" style={{ width: 80, marginBottom: 10 }} />
                                </div>
                            </Card.Body>
                        </Card></> : <>
                            <Card className="shadow-lg p-4 border-0" style={{ maxWidth: 400, background: 'linear-gradient(135deg, #ffe0e0 0%, #f0b2b2 100%)' }}>
                                <Card.Body className="text-center">
                                    <div style={{ fontSize: 60, color: '#dc3545' }}>
                                        <i className="uil uil-times-circle"></i>
                                    </div>
                                    <Card.Title className="mb-3 fw-bold" style={{ fontSize: 28, color: '#dc3545' }}>
                                        Cupón inválido
                                    </Card.Title>
                                    <Card.Text className="mb-4" style={{ fontSize: 18 }}>
                                        El cupón ingresado no es válido o ya fue utilizado.<br />
                                        <span className="fw-bold">Por favor, intenta con otro código.</span>
                                    </Card.Text>
                                    <div>
                                        <img src={logo} alt="Logo" style={{ width: 80, marginBottom: 10 }} />
                                    </div>

                                    <Button onClick={() => reloadPage()}>Intentar nuevamente</Button>
                                </Card.Body>
                            </Card>
                        </>}
                    </div>

                </>}



            </main>

        </>
    )
}

export default ApplyCuponRemote